import request from '@/utils/request'
// 运营策略列表
export function spWorkWechatOpStrategyIndex(params) {
  return request({
    url: '/spWorkWechat/opStrategy/index',
    method: 'get',
    params
  })
}
// 运营策略添加
export function spWorkWechatOpStrategyAdd(data) {
  return request({
    url: '/spWorkWechat/opStrategy/add',
    method: 'post',
    data
  })
}
// 企微消息的详情
export function sprEnterprise(params) {
  return request({
    url: '/spWorkWechat/spMessage/messageInfo',
    method: 'get',
    params
  })
}

// 运营策略修改
export function spWorkWechatOpStrategyupdate(data) {
  return request({
    url: '/spWorkWechat/opStrategy/update',
    method: 'post',
    data
  })
}
// 运营策略删除
export function spWorkWechatOpStrategydel(data) {
  return request({
    url: '/spWorkWechat/opStrategy/del',
    method: 'post',
    data
  })
}
// 绑定记录
export function spWorkWechatOpStrategyStaff_list(params) {
  return request({
    url: '/spWorkWechat/opStrategy/staff_list',
    method: 'get',
    params
  })
}
// 员工列表
export function spWorkWechatOpStrategyCorpUsersListForStrategy(params) {
  return request({
    url: '/spWorkWechat/opStrategy/corpUsersListForStrategy',
    method: 'get',
    params
  })
}
// 解绑员工
export function spWorkWechatOpStrategyStaff_unbind(data) {
  return request({
    url: '/spWorkWechat/opStrategy/staff_unbind',
    method: 'post',
    data
  })
}
// 绑定员工
export function spWorkWechatOpStrategyStaff_bind(data) {
  return request({
    url: '/spWorkWechat/opStrategy/staff_bind',
    method: 'post',
    data
  })
}
// 发送记录
export function spWorkWechatOpStrategySendRecord(params) {
  return request({
    url: '/spWorkWechat/opStrategy/sendRecord',
    method: 'get',
    params
  })
}
// 运营策略详情
export function spWorkWechatOpStrategyDetail(params) {
  return request({
    url: '/spWorkWechat/opStrategy/detail',
    method: 'get',
    params
  })
}
